import type { LDContext } from '../types/types';

/**
 * Get the key of a context.
 * @param context - The context to get the key of.
 * @returns The key of the context.
 */
export function getContextKey(context: LDContext): string {
  if ('key' in context) {
    return String(context.key);
  }
  return '';
}
